<template>
  <v-card tile outlined class="w-100 mt-5" :elevation="2">
    <v-form ref="form">
      <v-row class="ml-2">
        <v-col cols="4">
          <v-card-title class="primary--text">
            {{ title }}
          </v-card-title>
        </v-col>
        <v-col cols="6">
          <v-text-field v-model="newUrl" label="URL" :rules="[requiredRule, validURLRule]" :disabled="edit" required />
        </v-col>
        <v-col cols="2">
          <v-btn v-if="edit" depressed tile color="primary" class="mt-4 ml-2" @click="editWebhook">
            edit
          </v-btn>
          <v-btn v-else depressed tile color="primary" class="mt-4 ml-2" @click="handleSubmit">
            Submit
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>

export default {
  components: { },
  props: {
    title: { type: String, default: null },
    event: { type: String, default: null },
    data: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      newWebhook: true,
      edit: false,
      newUrl: this.data.url
    }
  },
  computed: {
    requiredRule() {
      return v => !!v || 'Value is required'
    },
    form() {
      return this.$refs.form
    },
    validURLRule() {
      return (value) => {
        try {
          return !!new URL(value)
        } catch (error) {
          return 'Invalid URL'
        }
      }
    }
  },
  mounted() {
    if (this.data.url) {
      this.edit = true
      this.newWebhook = false
    }
  },
  methods: {
    editWebhook() {
      this.edit = false
    },
    handleSubmit() {
      if (this.newWebhook) {
        this.createWebhook()
      } else {
        this.updateWebhook()
      }
    },
    updateWebhook() {
      if (this.$refs.form.validate()) {
        if (this.$refs.form.validate()) {
          this.$emit('submit', { id: this.data.id, url: this.newUrl, eventCode: this.event, newHook: false })
          this.edit = true
          this.newWebhook = false
        }
      }
    },
    createWebhook() {
      if (this.form.validate()) {
        this.$emit('submit', { url: this.newUrl, eventCode: this.event, newHook: true })
        this.edit = true
        this.newWebhook = false
      }
    }
  }
}
</script>
